export default __webpack_public_path__ + "static/blog-3-788d5fbc166b75252e76937a3d90c4f7.jpg";